var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fields_of_study_wrapper"},[_c('ProfileSubsectionTitle',{attrs:{"subsection_title":"Fields of Study"}}),_c('div',{staticClass:"fields_of_study_item_wrapper"},_vm._l((_vm.fields_of_studies),function(skill){return _c('SkillItem',{key:skill.id,attrs:{"skill":skill}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }